import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M32.672 6.0195C26.4915 1.99225 20.1949 1.68258 14.9248 6.99133C9.65882 12.2958 10.0551 18.5491 13.96 24.8686L26.0763 44.5723C28.3654 48.3439 28.5992 50.9569 26.3521 54.5474L14.678 73.7117C10.9087 79.7908 10.7446 86.0333 16.308 91.6375C21.8715 97.2417 28.0688 97.0767 34.1038 93.28L80.9266 63.7798C83.0303 62.4219 84.5839 61.4225 85.853 60.1443C91.1194 54.8398 90.5039 46.5337 85.0323 41.0225C83.7103 39.6911 82.2113 38.5473 80.527 37.3957L32.672 6.0195Z'

const IconButtonArrowRight: FC<IconProps> = props => (
  <SvgIcon {...props} path={PATH} viewBox="0 0 100 100" />
)

export default IconButtonArrowRight
